import { render, staticRenderFns } from "./ScreenLogout.vue?vue&type=template&id=0f80ea0e&scoped=true&"
import script from "./ScreenLogout.vue?vue&type=script&lang=js&"
export * from "./ScreenLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80ea0e",
  null
  
)

export default component.exports